import { useEffect } from 'react';
import { Params, useLocation, useNavigate, useParams } from 'react-router-dom';

type ToFn = (params: Readonly<Params<string>>) => string;

interface RewriteProps {
  to: string | ToFn;
  external?: boolean;
  excludeSearchParams?: boolean;
}

// <Rewrite to="/path" /> can be used to rewrite the beginning of a path.
// Example: <Route path="/create" element={<Rewrite to="/generate" />} />
// will rewrite any url like "/create/template?param=true" to "/generate/template?param=true"
export function Rewrite(props: RewriteProps) {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const generatePathPrefix = `${
    typeof props.to === 'function' ? props.to(params) : props.to
  }`;

  const generatePath = `${generatePathPrefix}${
    props.excludeSearchParams ? '' : `/${params['*']}${location.search}`
  }`;

  useEffect(() => {
    if (props.external) {
      window.location.replace(generatePath);
      return;
    }
    navigate(generatePath, { replace: true });
  }, [navigate, generatePath, props.external]);

  return null;
}
